import React, { useState } from 'react'
import clsx from 'clsx'
import { useLocation } from 'react-router'
import { checkIsActive, WithChildren } from '../../../../helpers'
import { useLayout } from '../../../core'

type Props = {
    to: string
    title: string
    icon?: string | JSX.Element   
    fontIcon?: string
    hasBullet?: boolean
    isOpen?: boolean
    toggleOpen?: () => void
    svgIcon?: JSX.Element
}

const SidebarMenuItemWithSub: React.FC<Props & WithChildren> = ({
    children,
    to,
    title,
    icon,
    fontIcon,
    hasBullet,
    isOpen,
    toggleOpen,
    svgIcon,
}) => {
    const { pathname } = useLocation()
    const isActive = checkIsActive(pathname, to)
    const { config } = useLayout()
    const { app } = config

    return (
        <div
            className={clsx('menu-item menu-accordion menu-main-p', {
                'here show': isOpen,
            })}
        >
            <span className='menu-link menu-link-p m-0' onClick={toggleOpen}>
                {hasBullet && (
                    <span className='menu-bullet'>
                        <span className='bullet bullet-dot'></span>
                    </span>
                )}

                {typeof icon === 'string' && app?.sidebar?.default?.menu?.iconType === 'svg' && (
                    <span className='menu-icon'>
                        <i className={`fs-2 bi bi-${icon}`}></i>
                    </span>
                )}

                {React.isValidElement(icon) && (
                    <span className='menu-icon'>{icon}</span>
                )}

                {fontIcon && app?.sidebar?.default?.menu?.iconType === 'font' && (
                    <i className={clsx('bi fs-3', fontIcon)}></i>
                )}

                <span className='menu-title'>{title}</span>

                <span className='menu-arrow-new'>
                    <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path opacity="0.5" d="M6.64645 0.146446C6.84171 -0.0488158 7.15829 -0.0488158 7.35355 0.146446C7.54882 0.341709 7.54882 0.658291 7.35355 0.853553L4.35355 3.85355C4.16427 4.04284 3.85947 4.04946 3.66214 3.86858L0.662141 1.11858C0.458581 0.93198 0.44483 0.615696 0.631426 0.412137C0.818022 0.208578 1.13431 0.194826 1.33787 0.381422L3.98496 2.80793L6.64645 0.146446Z" fill="white" />
                    </svg>

                </span>
            </span>

            <div className={clsx('menu-sub menu-sub-accordion', { 'menu-active-bg': isOpen })}>
            {children}
            </div>
        </div>
    )
}

export { SidebarMenuItemWithSub }
